import {TimelineLite, TweenLite} from "gsap";
import {
    SimplePresentationRunner,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {PearlHarbor} from "../PearlHarbor";

export class PearlHarborRestoreResizeArea implements SimplePresentationRunner {
    private _mainTL: TimelineMax;
    private _controller: SimplePresentationRunnerController;

    private complete(): void {
        this._controller.finish();
    }

    shouldRun(): boolean {
        return PearlHarbor.model.isRestore;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._controller = controller;
        this._mainTL = new TimelineLite();
        const border: number[] = [13, 0, 6, 0];
        const center: number = 48,
            borderData: number[] = PearlHarbor.model.initData.barriers;
        border[0] = Math.min((center + Math.max(borderData[0],-6)) % 14, border[0]);
        border[1] = Math.max((center + Math.min(borderData[1], 7)) % 14, border[1]);
        border[2] = Math.min(Math.floor((center + borderData[2]) / 14), border[2]);
        border[3] = Math.max(Math.floor((center + borderData[3]) / 14), border[3]);


        this._mainTL.add(PearlHarbor.activeSymbolsBackground.updateActiveArea(border), 0.1);
        this._mainTL.add(()=>{
            for(let i:number = 0; i<7; i++){
                PearlHarbor.allReelsView.mainReelModels[i].reelView.setSymbolActiveState();
                PearlHarbor.allReelsView.mainReelModels[i].reelView.playSymbolLandingOnRestore();
            }
            if(PearlHarbor.model.scatterCount>1){
                PearlHarbor.scatterAnimation.playAnticipation();
            }
        });
        if (this._mainTL.duration() == 0) {
            this._mainTL.add(TweenLite.to(this, {duration: 0.001}));


        }
        this._mainTL.add(() => this.complete());
    }
}